import {Box, Skeleton} from '@customink/pigment-react';
import React from 'react';

const SKELETON_COUNT = 8;

export default function ProductColorSwatchesSkeleton() {
  return (
    <Box
      sx={{
        paddingTop: {md: '0.5rem', sm: 0}
      }}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexFlow: 'row nowrap',
          gap: '0.5rem',
          justifyContent: 'flex-start',
          marginLeft: '-1rem',
          marginRight: '-1rem',
          paddingBottom: '0.25rem',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }}>
        {Array.from({length: SKELETON_COUNT}).map((_, index) => (
          <Skeleton
            // eslint-disable-next-line react/no-array-index-key
            key={`color-swatch-skeleton-${index}`}
            variant="rectangular"
            width="2rem"
            height="2rem"
            sx={{
              borderRadius: '0.25rem',
              flexShrink: 0
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
